<template>
  <div>
    <Table  ref="selection" :columns="columns12" :data="CommonCommodityLists" max-height="600">
        <template slot-scope="{ row, index }" slot="action">
            <a href="#" @click.prevent="EditHandleClick(index)">
            编辑
          </a>
            <Divider type="vertical" />
            <Poptip
            placement="left"
            confirm
            title="你确定要删除这条信息吗?"
            @on-ok="remove(index)"
            >
             <Button type="error" ghost size="small">删除</Button>
            </Poptip>
        </template>
    </Table>
  </div>
</template>

<script>
export default {
  name: 'NonStandardTable',
  props: {
    CommonCommodityLists: Array
  },
  data () {
    return {
      columns12: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: 'Openid',
          key: 'openid'
        },
        {
          title: '客户名称',
          key: 'Customer_Name'
        },
        {
          title: '物料大类',
          key: 'Classification'
        },
        {
          title: '物料编码',
          key: 'ProductID'
        },
        {
          title: '物料名称',
          key: 'Product_Name'
        },
        {
          title: '物料属性汇总',
          key: 'Attribute_Summary'
        },
        {
          title: '单重',
          key: 'SingleWeight'
        },
        {
          title: '辅助数量',
          key: 'AuxiliaryQuantity'
        },
        {
          title: '操作',
          slot: 'action',
          width: 150,
          align: 'center'
        }
      ]
    }
  },
  methods: {
    // show (index) {
    //   this.$Modal.info({
    //     title: 'User Info',
    //     content: `Name：${this.data6[index].name}<br>Age：${this.data6[index].age}<br>Address：${this.data6[index].address}`
    //   })
    // },
    // 点击编辑事件回调
    EditHandleClick (index) {
      this.$emit('EditHandleClick', index)
    },
    // 点击删除按钮回调
    remove (index) {
      // this.data6.splice(index, 1)
      this.$emit('DeleteHandleClick', index)
    }
  }
}
</script>
